import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=6c52dae2"
import script from "./ReviewStep.vue?vue&type=script&lang=js"
export * from "./ReviewStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports